import type { User } from '@entities/user';
import { BusAuthentication } from '@main/bus-layer/bus-authentication';
import { BUS_IFRAME_ELM_ID } from '@main/config/bus.config';
import type {
  UserUnifiedLoginAuthenticator,
  UserUnifiedLoginRequest,
} from '../usecases/user-unified-login.usecase';

export class BusUserUnifiedLoginAuthenticator
  implements UserUnifiedLoginAuthenticator
{
  private static Ins: BusUserUnifiedLoginAuthenticator;

  constructor() {
    return (
      BusUserUnifiedLoginAuthenticator.Ins ??
      (BusUserUnifiedLoginAuthenticator.Ins = this)
    );
  }

  async authenticate({
    token,
    refreshToken,
  }: UserUnifiedLoginRequest): Promise<User> {
    const target: HTMLIFrameElement = <HTMLIFrameElement>(
      document.getElementById(BUS_IFRAME_ELM_ID)
    );

    const {
      company,
      currentUser: info,
      credentials,
    } = await BusAuthentication.unifiedLogin(target, token, refreshToken);

    return {
      company,
      credentials,
      info,
    };
  }
}
